<ng-container>
  <div class="categories-wrapper"
       [ngClass]="{
        'categories-wrapper--no-background': !background
       }">
    <div class="container">
      <div class="row">
        <div class="gr-12"
             [ngClass]="{'gr-10@xl gr-centered@xl': rootCategory && background}">
          <h2 *ngIf="!rootCategory"
              class="h3-style spacing-down--05"
              i18n="more categories heading in category-tree-list // page: all pages with category tree @@category-tree-list.component_more-heading">More subcategories</h2>
          <ul class="row list--without-dots">
            <ng-container *ngTemplateOutlet="categoryTile; context: {advertised: false}"></ng-container>
            <ng-container *ngTemplateOutlet="linkTile"></ng-container>
            <ng-container *ngTemplateOutlet="categoryTile; context: {advertised: true}"></ng-container>
            <ng-container *ngIf="featureFlags.referenceProjects && rootCategory">
              <li class="gr-12">
                <p1-lib-ui-elements-image-tile [name]=""
                                               [link]="'https://leads.plan.one'"
                                               [fullWidth]="true"
                                               [openInNewTab]="true"
                                               [gtmEventCategory]="'Leads'"
                                               [gtmEventAction]="'Click leads'"
                                               [gtmEventLabel]="'Categorytree - Link'"
                                               [imageUuid]="'ca6733ea-92fd-4e50-86e8-da919dd51a2e'">
                </p1-lib-ui-elements-image-tile>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #categoryTile let-advertised="advertised">
  <ng-container *ngFor="let category of categoryTree; trackBy: identifyCategory; let i = index">
    <li *ngIf="(!advertised && !category?.advertised) || (advertised && category?.advertised)"
        class="gr-12 gr-6@m gr-4@l"
        [ngClass]="{'subcategory-tile gr-3@xl': !rootCategory}">
      <p1-category-tile [name]="category?.name"
                        [imageUuid]="category?.image?.uuid"
                        [childCategories]="category?.childNodes"
                        [advertising]="category?.advertised"
                        [pathedSlugs]="category?.pathedSlug"></p1-category-tile>
    </li>
    <li *ngIf="iphasCatalog && !advertised && i === 0" class="gr-12 gr-6@m gr-4@l">
      <div class="video--yt">
        <iframe
          *ngIf="locale === 'de-DE'"
          src="https://www.youtube-nocookie.com/embed/r8diFEWFY04"
          class="youtube-video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          frameborder="0"
          allowfullscreen="1"
          enablejsapi="0"></iframe>
        <iframe
          *ngIf="locale !== 'de-DE'"
          src="https://www.youtube-nocookie.com/embed/d4phHiSJgdk"
          class="youtube-video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          frameborder="0"
          allowfullscreen="1"
          enablejsapi="0"></iframe>
      </div>
    </li>
  </ng-container>
</ng-template>

<ng-template #linkTile>
  <li *ngFor="let linkTile of linkTiles; trackBy: identifyLinkTile"
      class="gr-12 gr-6@m gr-4@l"
      [ngClass]="{'subcategory-tile gr-3@xl': !rootCategory}">
    <p1-link-tile [linkTile]="linkTile"></p1-link-tile>
  </li>
</ng-template>
